import styled from 'styled-components';

export const ContentCard = styled.div`
  background: var(--beige-main);
  border: 1px solid var(--gray-dark);
  border-radius: var(--medium-border-radius);
  padding: 45px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
`;

export const ButtonContainer = styled.div`
  position: sticky;
  bottom: 0;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
  align-items: center;
  z-index: 10;
`;

export const IntroText = styled.div`
  font-family: var(--font-family);
  font-size: var(--medium-font-size);
  line-height: 1.4;
  color: var(--black-main);
  max-width: 838px;

  .bold {
    font-weight: 500;
  }
`;

export const StepsContainer = styled.div`
  padding: 1.5625rem 0;
  width: 100%;
`;

export const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.9375rem;
  position: relative;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const TimelineLine = styled.div`
  position: absolute;
  top: 0.8125rem;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--gray-dark);
  z-index: 0;

  @media (max-width: 968px) {
    display: none;
  }
`;

export const StepColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9375rem;
  position: relative;
  z-index: 1;
`;

export const StepNumber = styled.div`
  background: var(--white-main);
  border: 1px solid var(--gray-dark);
  border-radius: 0.8125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.625rem;
  width: 1.7046rem;
  font-family: var(--font-family);
  font-weight: 500;
  font-size: var(--xsmall-font-size);
  color: var(--black-main);
  line-height: 1.5;
  flex-shrink: 0;
`;

export const StepCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1875rem;
  text-align: center;
  color: var(--black-main);
  width: 100%;
`;

export const StepTitle = styled.p`
  font-family: var(--font-family);
  font-weight: 500;
  font-size: var(--small-font-size);
  line-height: 1.5;
  width: 100%;
  margin: 0;
`;

export const StepDescription = styled.p`
  font-family: var(--font-family);
  font-weight: 400;
  font-size: var(--xsmall-font-size);
  line-height: 1.5;
  width: 100%;
  margin: 0;

  a {
    text-decoration: underline;
    text-decoration-skip-ink: none;
    text-underline-position: from-font;
    color: var(--black-main);
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: var(--gray-darker);
`;

export const ErrorState = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: var(--red-main);
`;
